// Downtime classification thresholds (percent of day disconnected)
// High (error/red): > 30%
// Medium (warning/orange): 10% - 30%
// Low (info/blue): < 10%
export const DOWNTIME_HIGH_THRESHOLD = 30; // >30% downtime considered high severity
export const DOWNTIME_MEDIUM_THRESHOLD = 10; // 10-30% downtime medium severity

export const MINUTES_PER_DAY = 24 * 60;
export const MINUTES_PER_HOUR = 60;

export const SECONDS_PER_DAY = 24 * 60 * 60;
export const SECONDS_PER_MINUTE = 60;
